import * as R from 'ramda';
import { categoryDisplay, dimensionValueDisplay } from '../dimension-utils';
import { getFormatedObservation } from '../observation-formater';

const series = (
  observations,
  dimensions,
  dimensionsWithValuesIndexedById,
  symbolDimension,
  sortDirection,
  display,
  formaterAttrs,
) => {
  const symbolDimensionId = R.propOr(null, 'id', symbolDimension);
  if (symbolDimensionId === null) return [];
  const symbolDimIndex = R.findIndex(d => d.id === symbolDimensionId, dimensions);
  const datapoints = R.pipe(
    R.keys,
    R.reduce((acc, obsKey) => {
      const obs = observations[obsKey];
      if (R.isNil(R.head(obs)) || R.isEmpty(R.head(obs))) {
        return acc;
      }
      const obsDimsValsIndexes = R.split(':', obsKey);
      const symbolValIndex = Number(R.nth(symbolDimIndex, obsDimsValsIndexes));
      const symbolValId = R.path([symbolDimIndex, 'values', symbolValIndex, 'id'], dimensions);
      const symbolIndex = R.findIndex(R.propEq(symbolValId, 'id'), symbolDimension.serie);
      if (symbolIndex === -1) {
        return acc;
      }
      const category = categoryDisplay(
        obsDimsValsIndexes,
        dimensions,
        dimensionsWithValuesIndexedById,
        symbolDimensionId,
        display,
      );
      const ids = categoryDisplay(
        obsDimsValsIndexes,
        dimensions,
        dimensionsWithValuesIndexedById,
        symbolDimensionId,
        'code',
      );
      const key = R.isNil(ids) || R.isEmpty(ids) ? 'uniq-dp' : ids;
      const dpIndex = R.findIndex(R.propEq(key, 'key'), acc);
      const dp = R.pipe(
        dpIndex =>
          dpIndex === -1
            ? {
                category,
                formatedValues: new Array(R.length(symbolDimension.serie)),
                values: new Array(R.length(symbolDimension.serie)),
                key,
              }
            : R.nth(dpIndex, acc),
        R.set(R.lensPath(['values', symbolValIndex]), R.head(obs)),
        R.set(
          R.lensPath(['formatedValues', symbolValIndex]),
          getFormatedObservation(obs, formaterAttrs),
        ),
      )(dpIndex);
      return dpIndex === -1 ? R.append(dp, acc) : R.set(R.lensIndex(dpIndex), dp, acc);
    }, []),
    R.sortBy(d => R.head(d.values) * sortDirection),
  )(observations);

  const symbolValues = R.map(dimensionValueDisplay(display), symbolDimension.serie);
  return [{ datapoints, symbolValues }];
};

export default (
  { observations, dimensions },
  chartType,
  dimensionsWithValuesIndexedById,
  symbolDimension,
  display,
  formaterAttrs,
) => {
  switch (chartType) {
    case 'HorizontalSymbolChart':
      return series(
        observations,
        dimensions,
        dimensionsWithValuesIndexedById,
        symbolDimension,
        -1,
        display,
        formaterAttrs,
      );
    case 'VerticalSymbolChart':
      return series(
        observations,
        dimensions,
        dimensionsWithValuesIndexedById,
        symbolDimension,
        1,
        display,
        formaterAttrs,
      );
    default:
      return [];
  }
};
